import React, { useState } from 'react'
import printJS from 'print-js'
import {
  FileText,
  Building,
  CreditCard,
  Calendar,
  CheckCircle,
  ChevronLeft,
  ChevronRight
} from 'lucide-react'

const CompletedInstallmentsPrint = ({
  installments,
  totalPaidAmount,
  companyInfo,
  totalPlotAmount,
  adjustedTotalPaid = 0,
  installmentYears = 'N/A'
}) => {
  console.log('Adjusted Total Paid:', adjustedTotalPaid)
  console.log('Type of Adjusted Total Paid:', typeof adjustedTotalPaid)
  console.log('Installments:', installments)
  console.log('Company Info:', companyInfo)
  // Ensure adjustedTotalPaid is a number
  const safeAdjustedTotalPaid =
    typeof adjustedTotalPaid === 'number' ? adjustedTotalPaid : 0
  const formatCNIC = cnic => {
    if (!cnic) return ''
    return cnic.replace(/^(\d{5})(\d{7})(\d{1})$/, '$1-$2-$3')
  }

  const societyImage = companyInfo?.soc?.society_image || 'default-image.jpg'

  const handlePrint = () => {
    const printContent = `
      <div style="font-family: 'Inter', 'Arial', sans-serif; margin: 0; padding: 10px; max-width: 800px; margin: 0 auto; background: #f4f4f4;">
        <!-- Compact Header -->
        <div style="background: linear-gradient(135deg, #3b82f6, #1e40af); color: white; padding: 12px; border-radius: 8px; margin-bottom: 12px; box-shadow: 0 4px 8px rgba(0,0,0,0.1);">
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <div style="display: flex; align-items: center;">
              <img src="${societyImage}" alt="Society" style="width: 50px; height: 50px; border-radius: 50%; margin-right: 12px; border: 2px solid rgba(255,255,255,0.3); object-fit: cover;" />
              <div>
                <h1 style="margin: 0; font-size: 20px; font-weight: 700;">${companyInfo?.soc?.name || 'Property Management'
      }</h1>
                <p style="margin: 2px 0 0; opacity: 0.8; font-size: 11px;">Installment Summary Report</p>
                <p style="margin: 2px 0 0; opacity: 0.8; font-size: 11px;">${companyInfo?.soc?.location || ''
      }</p>
              </div>
            </div>
            <div style="text-align: right; background: rgba(255,255,255,0.2); padding: 8px; border-radius: 8px;">
              <p style="margin: 0; opacity: 0.9; font-size: 10px;">Total Paid</p>
              <p style="margin: 2px 0 0; font-size: 18px; font-weight: 800; color: white;">PKR ${safeAdjustedTotalPaid.toLocaleString(
        'en-US',
        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
      )}</p>
            </div>
          </div>
        </div>
  
        <!-- Compact Grid Layout -->
        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; margin-bottom: 12px;">
          <div style="background: white; padding: 12px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.06); border: 1px solid #e2e8f0;">
            <h3 style="font-size: 14px; margin-bottom: 8px; color: #3b82f6; border-bottom: 2px solid #3b82f6; padding-bottom: 4px;">Customer Details</h3>
            ${renderDetailCard(installments[0]?.customerDetails)}
          </div>
  
          <div style="background: white; padding: 12px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.06); border: 1px solid #e2e8f0;">
            <h3 style="font-size: 14px; margin-bottom: 8px; color: #3b82f6; border-bottom: 2px solid #3b82f6; padding-bottom: 4px;">Property Info</h3>
            ${renderPropertyDetails(companyInfo)}
          </div>
        </div>
  
        <!-- Compact Installments Table -->
        <div style="background: white; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.06); margin-bottom: 12px; border: 2px solid #3b82f6;">
          <table style="width: 100%; border-collapse: separate; border-spacing: 0;">
            <thead style="background-color: #f1f5f9;">
              <tr>
                <th style="padding: 8px; text-align: left; border-bottom: 2px solid #3b82f6; border-right: 1px solid #e2e8f0; font-size: 11px; color: #1e40af;">Installment no</th>
                <th style="padding: 8px; text-align: left; border-bottom: 2px solid #3b82f6; border-right: 1px solid #e2e8f0; font-size: 11px; color: #1e40af;">Receipt no</th>
                <th style="padding: 8px; text-align: left; border-bottom: 2px solid #3b82f6; border-right: 1px solid #e2e8f0; font-size: 11px; color: #1e40af;">Amount</th>
                <th style="padding: 8px; text-align: left; border-bottom: 2px solid #3b82f6; border-right: 1px solid #e2e8f0; font-size: 11px; color: #1e40af;">Date</th>
                <th style="padding: 8px; text-align: left; border-bottom: 2px solid #3b82f6; border-right: 1px solid #e2e8f0; font-size: 11px; color: #1e40af;">Payment Method</th>
                <th style="padding: 8px; text-align: left; border-bottom: 2px solid #3b82f6; font-size: 11px; color: #1e40af;">Status</th>
              </tr>
            </thead>
            <tbody>
              ${installments.map(renderInstallmentRow).join('')}
            </tbody>
          </table>
        </div>

        <!-- Compact Summary Section -->
        <div style="background: linear-gradient(135deg, #3b82f6, #1e40af); padding: 16px; border-radius: 12px; margin-bottom: 12px; box-shadow: 0 8px 16px rgba(0,0,0,0.1);">
          <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px;">
            ${renderSummaryCard(
        'Total Installments',
        installments.length,
        '#10b981',
        '#f0fdf4'
      )}
            ${renderSummaryCard(
        'Total Paid',
        `PKR ${safeAdjustedTotalPaid.toFixed(2)}`,
        '#3b82f6',
        '#f0f9ff'
      )}
            ${renderSummaryCard(
        'Avg Installment',
        `PKR ${(totalPaidAmount / installments.length).toFixed(2)}`,
        '#8b5cf6',
        '#f5f3ff'
      )}
          </div>
        </div>

        <!-- Compact Certification Section -->
        <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 16px;">
          <div style="width: 80px; height: 80px; border: 2px dotted #3b82f6; border-radius: 50%; display: flex; justify-content: center; align-items: center; opacity: 0.7;">
            <span style="font-size: 9px; color: #3b82f6; text-align: center;">OFFICIAL<br/>STAMP</span>
          </div>
          <div style="width: 160px; height: 60px; border: 2px dotted #1e40af; border-radius: 8px; display: flex; justify-content: center; align-items: center; opacity: 0.7;">
            <span style="font-size: 9px; color: #1e40af; text-align: center;">Customer Signature<br/>& Authorization</span>
          </div>
        </div>
      </div>
    `

    // Create a new window for printing
    const printWindow = window.open('', '_blank', 'width=800,height=600')

    const completePrintContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Completed Installments Summary</title>
        <style>
          @media print {
            @page { 
              size: A4 portrait; 
              margin: 12mm; 
            }
            body { 
              margin: 0; 
              font-family: 'Inter', 'Arial', sans-serif;
              line-height: 1.3;
              color: #333;
            }
            .no-print { display: none !important; }
            * { 
              -webkit-print-color-adjust: exact !important;
              color-adjust: exact !important;
            }
          }
          body { 
            font-family: 'Inter', 'Arial', sans-serif; 
            margin: 0; 
            padding: 16px; 
            background: white;
            line-height: 1.3;
          }
          .print-btn { 
            background: #3b82f6; 
            color: white; 
            padding: 12px 24px; 
            border: none; 
            border-radius: 8px; 
            cursor: pointer; 
            font-size: 16px; 
            margin: 20px 0; 
          }
          .print-btn:hover { 
            background: #1e40af; 
          }
        </style>
      </head>
      <body>
        ${printContent}
        
        <div style="text-align: center; margin-top: 16px;">
          <button onclick="window.print()" class="print-btn no-print">
            Print Summary
          </button>
        </div>
      </body>
      </html>
    `

    // Write content to the new window and print
    printWindow.document.write(completePrintContent)
    printWindow.document.close()

    // Wait for content to load then print
    printWindow.onload = function () {
      printWindow.print()
      printWindow.close()
    }

    function renderDetailCard(customerDetails) {
      return `
        <div style="display: grid; gap: 8px;">
          <div style="background: #f8fafc; padding: 8px; border-radius: 6px;">
            <p style="margin: 0; color: #64748b; font-size: 10px;">Name</p>
            <p style="margin: 2px 0 0; font-weight: 500; font-size: 12px;">${customerDetails?.name || 'N/A'
        }</p>
          </div>
          <div style="background: #f8fafc; padding: 8px; border-radius: 6px;">
            <p style="margin: 0; color: #64748b; font-size: 10px;">Contact</p>
            <p style="margin: 2px 0 0; font-weight: 500; font-size: 12px;">${customerDetails?.phone || 'N/A'
        }</p>
          </div>
          <div style="background: #f8fafc; padding: 8px; border-radius: 6px;">
            <p style="margin: 0; color: #64748b; font-size: 10px;">CNIC</p>
            <p style="margin: 2px 0 0; font-weight: 500; font-size: 12px;">${formatCNIC(customerDetails?.cnic) || 'N/A'
        }</p>
          </div>
          <div style="background: #f8fafc; padding: 8px; border-radius: 6px;">
            <p style="margin: 0; color: #64748b; font-size: 10px;">Installment Plan</p>
            <p style="margin: 2px 0 0; font-weight: 500; font-size: 12px;">${installmentYears} years </p>
          </div>
        </div>
      `
    }

    function renderPropertyDetails(companyInfo) {
      return `
        <div style="display: grid; gap: 8px;">
          <div style="background: #f8fafc; padding: 8px; border-radius: 6px;">
            <p style="margin: 0; color: #64748b; font-size: 10px;">Society</p>
            <p style="margin: 2px 0 0; font-weight: 600; font-size: 12px; color: #1e40af;">${companyInfo?.soc?.name || companyInfo?.societyName || 'Society'}</p>
          </div>
          <div style="background: #f8fafc; padding: 8px; border-radius: 6px;">
            <p style="margin: 0; color: #64748b; font-size: 10px;">Plot Details</p>
            <p style="margin: 2px 0 0; font-weight: 500; font-size: 12px;">${companyInfo.plot_type
        } - Plot #${companyInfo.plot_number}</p>
            <p style="margin: 2px 0 0; color: #64748b; font-size: 11px;">${companyInfo.block
        }</p>
            <p style="margin: 2px 0 0; color: #64748b; font-size: 11px;">${companyInfo.size
        } Marla</p>
          </div>

          ${renderPaymentDetails(installments)}
        </div>
      `
    }

    function renderPaymentDetails(installments) {
      return `
        <div style="display: grid; gap: 8px;">
          <div style="background: #f0fdf4; padding: 8px; border-radius: 6px;">
            <p style="margin: 0; color: #15803d; font-size: 10px;">Total Plot Amount</p>
            <p style="margin: 2px 0 0; font-weight: 600; font-size: 16px;">PKR ${totalPlotAmount
          ? totalPlotAmount.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
          : '0.00'
        }</p>
          </div>
          <div style="background: #fef3c7; padding: 8px; border-radius: 6px;">
            <p style="margin: 0; color: #d97706; font-size: 10px;">Initial Payment</p>
            <p style="margin: 2px 0 0; font-weight: 600; font-size: 14px;">PKR ${(
          companyInfo?.initial_payment ||
          companyInfo?.booking_amount ||
          0
        ).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}</p>
          </div>
        </div>
      `
    }

    function renderInstallmentRow(inst) {
      return `
        <tr style="border-bottom: 1px solid #e2e8f0;">
          <td style="padding: 8px; border-right: 1px solid #e2e8f0; font-size: 11px;">${inst.installment_number
        }</td>
          <td style="padding: 8px; border-right: 1px solid #e2e8f0; font-size: 11px;">${inst.receipt_no || 'N/A'
        }</td>
          <td style="padding: 8px; border-right: 1px solid #e2e8f0; font-size: 11px;">PKR ${(inst.paid_amount || 0).toLocaleString(
          'en-US',
          { minimumFractionDigits: 2, maximumFractionDigits: 2 }
        )}</td>
                     <td style="padding: 8px; border-right: 1px solid #e2e8f0; font-size: 11px;">${inst.payment_date ? new Date(inst.payment_date).toLocaleDateString('en-GB') : 'Not Paid'
        }</td>
          <td style="padding: 8px; border-right: 1px solid #e2e8f0; font-size: 11px;">${inst.payment_method || 'Not Specified'
        }</td>
          <td style="padding: 8px; font-weight: 500; color: ${inst.status === 'Completed' ? '#10b981' : inst.status === 'Pending' ? '#f59e0b' : '#ef4444'
        }; font-size: 11px;">${inst.status}</td>
        </tr>
      `
    }

    function renderSummaryCard(
      label,
      value,
      accentColor = '#3b82f6',
      bgColor = '#f0f9ff'
    ) {
      // Special handling for numeric values in strings starting with "PKR"
      let formattedValue = value
      if (typeof value === 'string' && value.startsWith('PKR ')) {
        // Extract the numeric part and format it
        const numericPart = parseFloat(value.replace('PKR ', ''))
        if (!isNaN(numericPart)) {
          formattedValue = `PKR ${numericPart.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}`
        }
      } else if (typeof value === 'number') {
        // Format plain numbers
        formattedValue = value.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      }

      return `
        <div style="background: ${bgColor}; padding: 12px; border-radius: 8px; text-align: center; box-shadow: 0 4px 12px rgba(0,0,0,0.08); border: 2px solid ${accentColor}20;">
          <p style="margin: 0; color: ${accentColor}; font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 6px;">${label}</p>
          <p style="margin: 0; font-size: 16px; font-weight: 700; color: ${accentColor};">${formattedValue}</p>
        </div>
      `
    }

    printJS({
      printable: printContent,
      type: 'raw-html',
      style: `
        @page { 
          size: A4 portrait; 
          margin: 12mm; 
        }
        body { 
          margin: 0; 
          font-family: 'Inter', Arial, sans-serif; 
          line-height: 1.3;
          color: #333;
        }
        * { 
          -webkit-print-color-adjust: exact !important;
          color-adjust: exact !important;
        }
      `
    })
  }

  const [currentPage, setCurrentPage] = useState(1)
  const installmentsPerPage = 5

  // Pagination logic
  const indexOfLastInstallment = currentPage * installmentsPerPage
  const indexOfFirstInstallment = indexOfLastInstallment - installmentsPerPage
  const currentInstallments = installments.slice(
    indexOfFirstInstallment,
    indexOfLastInstallment
  )

  const totalPages = Math.ceil(installments.length / installmentsPerPage)

  const handlePageChange = pageNumber => {
    setCurrentPage(pageNumber)
  }

  return (
    <div className='bg-white w-full rounded-xl shadow-lg border border-blue-200 overflow-hidden'>
      <div className='bg-gradient-to-r from-blue-600 to-blue-500 text-white p-5 flex justify-between items-center'>
        <div className='flex items-center space-x-4'>
          <CheckCircle className='w-10 h-10 text-white/80' strokeWidth={1.5} />
          <div>
            <h1 className='text-2xl font-extrabold tracking-tight'>
              Installment Summary
            </h1>
            <p className='text-sm text-white/70'>
              Complete Payment History
            </p>
          </div>
        </div>
        <div className='text-right'>
          <p className='text-xs text-white/60 mb-1'>Total Paid Amount</p>
          <p className='text-2xl font-bold text-white'>
            PKR {adjustedTotalPaid.toLocaleString()}
          </p>
        </div>
      </div>

      <div className='grid grid-cols-3 gap-4 p-5'>
        <div className='bg-blue-50/50 p-4 rounded-2xl text-center border border-blue-200 hover:shadow-md transition-all'>
          <Calendar
            className='mx-auto text-blue-600 w-8 h-8 mb-3'
            strokeWidth={1.5}
          />
          <p className='text-sm text-gray-600 mb-1'>Total Installments</p>
          <p className='font-bold text-gray-800 text-xl'>
            {installments.length}
          </p>
        </div>
        <div className='bg-green-50/50 p-4 rounded-2xl text-center border border-green-200 hover:shadow-md transition-all'>
          <CreditCard
            className='mx-auto text-green-600 w-8 h-8 mb-3'
            strokeWidth={1.5}
          />
          <p className='text-sm text-gray-600 mb-1'>Total Paid Amount</p>
          <p className='font-bold text-gray-800 text-xl'>
            PKR {adjustedTotalPaid.toLocaleString()}
          </p>
        </div>
        <div className='bg-purple-50/50 p-4 rounded-2xl text-center border border-purple-200 hover:shadow-md transition-all'>
          <Building
            className='mx-auto text-purple-600 w-8 h-8 mb-3'
            strokeWidth={1.5}
          />
          <p className='text-sm text-gray-600 mb-1'>Average Installment</p>
          <p className='font-bold text-gray-800 text-xl'>
            PKR {(totalPaidAmount / installments.length || 0).toLocaleString()}
          </p>
        </div>
      </div>

      <div className='overflow-x-auto px-5 pb-5'>
        <table className='w-full border-collapse rounded-lg overflow-hidden'>
          <thead>
            <tr className='bg-blue-600 text-white'>
              <th className='p-3 text-left first:rounded-tl-lg last:rounded-tr-lg'>
                Installment No.
              </th>
              <th className='p-3 text-left'>Amount</th>
              <th className='p-3 text-left'>Payment Date</th>
              <th className='p-3 text-left'>Status</th>
            </tr>
          </thead>
          <tbody>
            {currentInstallments.map(inst => (
              <tr
                key={inst.installment_number}
                className='border-b border-blue-100 even:bg-blue-50/30 hover:bg-blue-100/50 transition-colors'
              >
                <td className='p-3 text-gray-700'>{inst.installment_number}</td>
                <td className='p-3 text-gray-700'>
                  PKR {inst.paid_amount.toLocaleString()}
                </td>
                <td className='p-3 text-gray-700'>
                  {new Date(inst.payment_date).toLocaleDateString('en-GB')}
                </td>
                <td className='p-3 text-gray-700'>{inst.status}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Pagination Controls */}
        <div className='flex justify-center items-center mt-4 space-x-2'>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className='p-2 rounded-lg disabled:opacity-50 hover:bg-blue-100 transition-colors'
          >
            <ChevronLeft className='w-5 h-5 text-blue-600' />
          </button>

          <div className='text-sm text-gray-600'>
            Page {currentPage} of {totalPages}
          </div>

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className='p-2 rounded-lg disabled:opacity-50 hover:bg-blue-100 transition-colors'
          >
            <ChevronRight className='w-5 h-5 text-blue-600' />
          </button>
        </div>
      </div>

      <div className='p-5 border-t border-blue-100 bg-blue-50/30 flex justify-end'>
        <button
          onClick={handlePrint}
          className='px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2 shadow-md'
        >
          <FileText className='w-5 h-5' strokeWidth={1.5} />
          <span>Print Summary</span>
        </button>
      </div>
    </div>
  )
}

export default CompletedInstallmentsPrint
